// Câblage des évènements Umami sans clic du controller `track` (extrait pour être
// testable sous node (`observe` est injecté : esbuild accepte les imports sans
// extension, pas node). Rien sur l'aperçu Turbo : la page réelle va suivre (même
// garde que page_view). Renvoie la fonction d'arrêt de l'observation, ou null.
export function trackOnConnect({ doc = document, element, fireOnConnect, fireOnVisible, fire, observe }) {
  if (doc.documentElement.hasAttribute("data-turbo-preview")) return null
  if (fireOnConnect) fire()
  return fireOnVisible ? observe(element, fire) : null
}
